"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnFormatter = void 0;
class ColumnFormatter {
  format;
  constructor(parserOptions) {
    if (parserOptions.trim) {
      this.format = col => {
        return col.trim();
      };
    } else if (parserOptions.ltrim) {
      this.format = col => {
        return col.trimLeft();
      };
    } else if (parserOptions.rtrim) {
      this.format = col => {
        return col.trimRight();
      };
    } else {
      this.format = col => {
        return col;
      };
    }
  }
}
exports.ColumnFormatter = ColumnFormatter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDb2x1bW5Gb3JtYXR0ZXIiLCJmb3JtYXQiLCJjb25zdHJ1Y3RvciIsInBhcnNlck9wdGlvbnMiLCJ0cmltIiwiY29sIiwibHRyaW0iLCJ0cmltTGVmdCIsInJ0cmltIiwidHJpbVJpZ2h0IiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wYXJzZXIvY29sdW1uL0NvbHVtbkZvcm1hdHRlci50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBRUEsTUFBYUEsZUFBZTtFQUNSQyxNQUFNO0VBRXRCQyxZQUFtQkMsYUFBNEI7SUFDM0MsSUFBSUEsYUFBYSxDQUFDQyxJQUFJLEVBQUU7TUFDcEIsSUFBSSxDQUFDSCxNQUFNLEdBQUlJLEdBQVcsSUFBWTtRQUNsQyxPQUFPQSxHQUFHLENBQUNELElBQUksRUFBRTtNQUNyQixDQUFDO0lBQ0wsQ0FBQyxNQUFNLElBQUlELGFBQWEsQ0FBQ0csS0FBSyxFQUFFO01BQzVCLElBQUksQ0FBQ0wsTUFBTSxHQUFJSSxHQUFXLElBQVk7UUFDbEMsT0FBT0EsR0FBRyxDQUFDRSxRQUFRLEVBQUU7TUFDekIsQ0FBQztJQUNMLENBQUMsTUFBTSxJQUFJSixhQUFhLENBQUNLLEtBQUssRUFBRTtNQUM1QixJQUFJLENBQUNQLE1BQU0sR0FBSUksR0FBVyxJQUFZO1FBQ2xDLE9BQU9BLEdBQUcsQ0FBQ0ksU0FBUyxFQUFFO01BQzFCLENBQUM7SUFDTCxDQUFDLE1BQU07TUFDSCxJQUFJLENBQUNSLE1BQU0sR0FBSUksR0FBVyxJQUFZO1FBQ2xDLE9BQU9BLEdBQUc7TUFDZCxDQUFDO0lBQ0w7RUFDSjs7QUFyQkpLLE9BQUEsQ0FBQVYsZUFBQSxHQUFBQSxlQUFBIiwiaWdub3JlTGlzdCI6W119